import { getProducts } from '@lib/firestore'
import { useEffect, useState } from 'react'

export const useProductCatalog = () => {
  const [products, setProducts] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const fetchedProducts = await getProducts({ includeInactive: false })
        setProducts(fetchedProducts)
      } catch (error) {
        console.error('Error al obtener productos:', error)
      } finally {
        setLoading(false)
      }
    }
    fetchProducts()
  }, [])

  return { products, loading }
}
